/* eslint-disable max-lines */
export default {
    // creation_date: 'Fecha creación',
    ACCOUNT_HOLDER: 'Titular cuenta',
    account: 'Cuenta',
    account_holder: 'Titular cuenta',
    account_id: 'UUID cuenta',
    account_id_object: 'ID Cuenta',
    account_issues_count: 'Casos abiertos',
    account_number: 'Número cuenta',
    account_type: 'Tipo de cuenta',
    account_uuid: 'UUID Cuenta',
    accounts: 'Cuentas',
    active: 'Activo',
    added_operation: 'Operación añadida',
    alias: 'Alias de la cuenta',
    alias_account: 'Alias de la cuenta',
    aml_checked_on: 'AML - checked on',
    aml_code: 'AML - código',
    aml_description: 'AML - descripción',
    aml_evidence: 'AML - evidencia',
    aml_warning: 'AML - warning',
    amount_shares_indicator: 'Indicador tipo cantidad',
    annual_reporting: 'Indicador inf. anual',
    apply_reduction_coefficient: 'Reducción de coeficiente',
    asignee: 'Responsable',
    back_document: 'Imagen reverso documento',
    balance_treatment: 'Trato de balance',
    bde_code: 'Código BDE',
    bgs_code: 'Código BGS',
    bic_code: 'Código BIC',
    birth_date: 'Fecha nacimiento / constitución',
    birthdate: 'Fecha nacimiento / constitución',
    block_xt_transfers: 'Bloqueo trasp. salida ext.',
    blocking: 'Bloqueante',
    blocking_date: 'Fecha bloqueo',
    book: 'Libro',
    brand_name: 'Razón social',
    can_be_sent_to_rd: 'Puede ser enviado',
    can_be_validated: 'Puede ser validado',
    cash: 'Importe',
    category: 'Categoría',
    ccc_direct_billing: 'Cuenta de facturación directa',
    ccc_legal_guardian: 'Guardian legal de cuenta',
    cee_indicator: 'Indicador comunitario',
    cee_resident: 'Indicador comunitario',
    city: 'Localidad',
    city_of_birth: 'Ciudad nacimiento',
    class: 'Clase',
    closing_date: 'Fecha baja',
    cnae_code: 'CNAE Código',
    cnae_group: 'CNAE Grupo',
    cnae_subgroup: 'CNAE Subgrupo',
    cnmv_code: 'Código CNMV',
    com_comision: 'Com comision',
    comision: 'Comision',
    commercial_register: 'Registro Mercantil',
    commission: 'Comision',
    confirm_ops: 'Ind. confirmación operaciones',
    contact_language: 'Idioma de contacto',
    contact_medium: 'Método de contacto',
    country: 'País',
    country_fatca: 'País FATCA',
    country_residence: 'País residencia',
    created_on: 'Creado',
    creation_date: 'Fecha alta',
    crs_indicator: 'Indicador CRS',
    // custom_legal_entity_type: 'Indique la entidad legal',
    date_of_asset_value: 'Fecha valor liquidativo',
    dato1: 'Dato1',
    dato2: 'Dato2',
    dato3: 'Dato3',
    dato4: 'Dato4',
    dato5: 'Dato5',
    dato6: 'Dato6',
    dealer: 'Distribuidor',
    deathdate: 'Fecha fallecimiento',
    decease_date: 'Fecha fallecimiento',
    deleted_on: 'Fecha eliminación',
    department: 'Departamento',
    description: 'Descripción',
    dgs_code: 'Código DGS',
    direction_type: 'Tipo dirección',
    disability: 'Minusvalía',
    disability_percentage: 'Grado minusvalía',
    disability_grade: 'Grado minusvalía',
    display_name: 'Nombre',
    distributor: 'Distribuidor',
    distributors: 'Distribuidores',
    document_expiration_date: 'Fecha expiración',
    document_front_thumbnail: 'Preview documento (anverso)',
    document_id: 'Nº de Documento',
    document_number: 'Número de documento',
    document_reverse_thumbnail: 'Preview documento (reverso)',
    document_subcategory: 'Subcategoría',
    document_type: 'Tipo documento',
    door: 'Puerta',
    due_date: 'Fecha límite',
    email: 'Email',
    email_action: 'Tratamiento de Email',
    entity_type: 'Tipo entidad',
    expenses: 'Expenses',
    expiration_date: 'Fecha expiración',
    expires_on: 'Expiración',
    external_code: 'Cód. Externo',
    extlink_rd: 'Cód. Externo',
    f_address_city: 'Población',
    f_address_door: 'Puerta',
    f_address_floor: 'Piso',
    f_address_key_country: 'País',
    f_address_state: 'Provincia',
    f_address_key_state: 'Código de provincia',
    f_address_number: 'Número',
    f_address_postal_code: 'Código postal',
    f_address_street_1: 'Dirección 1',
    f_address_street_2: 'Dirección 2',
    facebook: 'Facebook',
    family_name: 'Apellidos',
    family_name_1: 'Primer apellido',
    family_name_2: 'Segundo apellido',
    fatca_status: 'Estatus FATCA',
    fax_country: 'País del fax',
    fax_number: 'Número de fax',
    fax_prefix: 'Prefijo fax',
    ffi_eni_code: 'Código FFI ENI',
    ffi_group: 'Grupo FFI',
    finance_entity: 'Entidad financiera',
    first_subscription_date: 'Fecha 1ª aportación',
    fiscal_address: 'Dirección fiscal',
    fiscal_date: 'Fecha fiscal',
    fiscal_group: 'Grupo retención',
    fiscal_import: 'Importe fiscal',
    fiscal_residence: 'País residencia fiscal',
    fiscal_treatment: 'Trato fiscal',
    floor: 'Planta',
    foreign_indicator: 'Indicador nacional extranjero',
    front_document: 'Imagen anverso documento',
    fund_participations: 'Fund participation',
    gender: 'Sexo',
    general_worth: 'Valor general',
    giin_code: 'Código GIIN',
    given_name: 'Nombre',
    gross_amount: 'Importe bruto',
    group: 'Grupo',
    group_assigned: 'Grupo asignado',
    has_docs_validated: 'Tiene documentos validados',
    has_docs_signed: 'Tiene documentos firmados',
    has_done_private_area_first_login: 'Primer acceso al área privada',
    has_draft_data: 'Datos pendientes de bastantear',
    without_has_draft_data_pending: 'Sin datos pendientes',
    with_has_draft_data_pending: 'Datos pendientes',
    has_docs_pending_validation: 'Documentos pendientes de bastantear',
    without_has_docs_pending_validation: 'Sin documentos pendientes',
    with_has_docs_pending_validation: 'Documentos pendientes',
    has_finveris_account: 'cuenta en Finveris',
    has_active_position: 'Tiene posiciones activas',
    holder_name: 'Nombre y apellidos del primer titular',
    holding_percentage: '% participación',
    home_phone: 'Teléfono casa',
    iban_code: 'Código IBAN',
    id_document_type: 'Tipo documento',
    id_object: 'ID del objeto',
    identity_document: 'Documento de identidad',
    identity_document_expiration_date: 'Expiración documento identidad',
    identity_document_type: 'Tipo documento identidad',
    ignore_fiscal_group: 'Ind. exclusión del grupo fiscal',
    indicator_fatca: 'Indicador FATCA',
    instagram: 'Instagram',
    intervener_issues_count: 'Casos abiertos',
    intervener_status: 'Estado',
    intervener_type: 'Tipo de interviniente',
    investor_class: 'Tipo de inversor',
    interveners: 'Intervinientes',
    intervener: 'Interviniente',
    intlink_rd: 'Cód. Interno',
    is_deleted: 'Eliminado',
    is_document_permanent: 'Documento sin fecha expiración',
    is_financial_entity: 'Entidad financiera',
    is_periodic: 'Operación periódica',
    is_periodic_request: 'Operación periódica desencadenante',
    is_request: 'Es solicitud',
    is_total_redemption: 'Reembolso total',
    is_total_transfer: 'Traspaso total',
    is_transfers_blocked: 'Bloqueo de traspasos',
    is_web_access_authorized: 'Acceso web autorizado',
    is_withholding_tax_exempt: 'Indicador exención retención',
    itemization_date: 'Fecha itemización',
    itemization_type: 'Tipo itemización',
    key_account_arragement_type: 'Tipo cuenta',
    key_city_of_birth: 'Ciudad nacimiento',
    key_country_nationality1: 'Nacionalidad 1',
    key_country_nationality2: 'Nacionalidad 2',
    key_country_of_birth: 'País nacimiento / constitución',
    key_entity_type: 'Tipo entidad',
    key_home_phone_prefix: 'Prefijo casa',
    key_issue_source: 'Fuente',
    key_issue_type: 'Tipo incidencia',
    key_legal_person_type: 'Tipo Entidad (Jurídicas)',
    key_marital_status: 'Estado civil',
    key_mobile_phone_prefix: 'Prefijo móvil',
    key_name: 'Key',
    key_crs_country: 'País CRS',
    key_nationality_1: 'Nacionalidad 1',
    key_nationality_2: 'Nacionalidad 2',
    key_operation_type: 'Tipo operación',
    key_sub_operation_type: 'Subtipo operación',
    key_other_phone_prefix: 'Prefijo otro',
    key_product: 'Fondo',
    key_profession: 'Profesión',
    key_profession_area: 'Area profesional',
    key_state: 'Código de provincia/región',
    key_status: 'Estado',
    key_tin_issuer_country: 'País',
    key_work_phone_prefix: 'Prefijo trabajo',
    lastname_1: 'Apellido 1',
    lastname_2: 'Apellido 2',
    // legal_entity_type: 'Entidad legal',
    legal_type: 'Tipo Entidad (Jurídicas)',
    lei_code: 'Código LEI',
    lei_expiration_date: 'Fecha caducidad LEI',
    linkedin: 'Linkedin',
    mailing_type: 'Tipo de comunicación',
    marital_regime: 'Regimen matrimonial',
    marital_status: 'Estado civil',
    matrimonial_regime: 'Régimen matrimonial',
    minor: 'Indicador menor',
    mobile_country: 'País del móvil',
    mobile_number: 'Número móvil',
    mobile_phone: 'Teléfono móvil',
    mobile_prefix: 'Prefijo',
    naisc_code: 'Código NAISC',
    name: 'Nombre',
    name_product: 'Fondo',
    nationality_country: 'País nacionalidad fiscal',
    nav: 'Valor liquidativo',
    nav_date: 'Fecha VL',
    net: 'Net',
    net_amount: 'Importe neto',
    net_asset_value: 'Valor liquidativo',
    net_value: 'Liquidativo',
    net_value_date: 'Fecha valor liquidativo',
    notary: 'Notario',
    notes: 'Notas',
    nullified: 'Anulada',
    number: 'Número',
    object: 'Objeto',
    object_type: 'Tipo de objecto',
    opening_date: 'Fecha alta',
    operation_date: 'Fecha operación',
    operation_id: 'UUID operación',
    operation_issues_count: 'Casos pendientes',
    operation_status: 'Estado',
    operation_sub_type: 'Subtipo operación',
    operation_type: 'Tipo operación',
    operations: 'Operaciones',
    orden: 'Orden',
    other_phone: 'Otro teléfono',
    parent_product_name: 'Fondo padre',
    participation_type: 'Tipo participación',
    participations: 'Participaciones',
    password: 'Contraseña',
    patrimony: 'Patrimonio',
    pay_method: 'Tipo pago',
    per_end_date: 'Fecha fin operación (periódica)',
    per_increase: 'Revalorización (periódica)',
    per_increase_period: 'Periodicidad de revalorización (periódica)',
    per_increase_type: 'Tipo revalorización (periódica)',
    per_period: 'Periodicidad (periódica)',
    per_uuid_operation_periodic_request: 'UUID operación desencadenante (periódica)',
    per_start_date: 'Comienzo operación periodica (periódica)',
    periodic_operation: 'Operación periódica',
    permission_set: 'Conjunto de permisos',
    phone1_country: 'País teléfono 1',
    phone2_country: 'País teléfono 2',
    phone3_country: 'País teléfono 3',
    photo: 'Imagen',
    postal_code: 'Código postal',
    postmail_action: 'Tratamiento de correspondencia',
    pp_compartment: 'Compartimentos (rescate/traspaso PP)',
    pp_plan_type: 'Tipo plan(traspaso PP)',
    pp_redemption_cause: 'Causa rescate (rescate)',
    pp_redemption_collection_method: 'Forma cobro (rescate)',
    pp_redemption_defer: 'Aplazamiento (rescate)',
    pp_redemption_entitlement_date: 'Fecha percepcion (rescate)',
    pp_redemption_mixed_amount: 'Cantidad periódica (rescate renta mixta)',
    pp_redemption_rendering_variation: 'Cantidad variación (rescate)',
    pp_redemption_rendering_variation_date: 'Fecha adelanto (rescate)',
    pp_redemption_rendering_variation_type: 'Tipo variación (rescate)',
    ind_percepcion_pres: 'Percepción (rescate)',
    ind_tipo_pres: 'Tipo prestación (rescate)',
    pp_rights_type: 'Tipo derechos (traspaso PP)',
    pp_source_situation: 'Situación origen (traspaso PP)',
    pp_xt_dgs_code: 'Código DGS (traspaso PP)',
    pp_xt_egs_code: 'Código EGS  (traspaso PP)',
    product_id: 'UUID de Producto',
    product_name: 'Nombre de producto',
    profession: 'Profesión',
    profession_area: 'Área profesional',
    proof_of_life_date: 'Fe de vida',
    proof_of_life_document: 'Documento Fe de vida',
    protocol: 'Protocolo',
    qi_eni_code: 'Código QI ENI',
    real_worth: 'Valor real',
    refund: 'Reembolso',
    registrales_1: 'Notario',
    registrales_2: 'Libro, Sección, Tomo, Folio, Hoja',
    registrales_3: 'Cod. DGS',
    registrales_4: 'Protocolo',
    registrales_5: 'Cod. CNMV',
    registrales_6: 'Registro mercantil',
    registrales_7: 'Cod. Bde',
    registration_date: 'Fecha registro',
    registration_name: 'Razón social',
    registration_page: 'Folio',
    rejection_cause: 'Causa de rechazo',
    removed: 'Eliminado',
    removed_on: 'Fecha eliminado',
    request_date: 'Fecha solicitud',
    requester_document_id: 'Nº de Documento',
    resolved_on: 'Fecha resolución',
    safety_indicator: 'Indicador de seguridad',
    saldo_participaciones: 'Saldo participaciones',
    section: 'Sección',
    semestral_reporting: 'Indicador inf. semestral',
    settlement_date: 'Fecha liquidación',
    shares: 'Participaciones',
    sheet: 'Hoja',
    signature_type: 'Tipo de firma',
    source: 'Canal',
    source_system: 'Sistema fuente',
    spanish_resident: 'Indicador nacional o extranjero',
    special_worth: 'Valor especial',
    state: 'Provincia/Región',
    status: 'Estado',
    street: 'Domicilio',
    street_1: 'Domicilio 1',
    street_2: 'Información adicional',
    subcategory: 'Subcategoría',
    subdealer: 'Subdistribuidor',
    subdistributor: 'Subdistribuidor',
    subject: 'Asunto',
    swift_code: 'Código SWIFT',
    swift_or_bic_code: 'Código SWIFT o BIC',
    tax_identification_number: 'Número de identificación fiscal',
    telephone: 'Teléfono',
    text_address: 'Dirección',
    text_town: 'Localidad',
    tin_code: 'Código TIN',
    tin_country: 'País emisor',
    tin_expiration_date: 'Fecha caducidad TIN',
    tin_type: 'Tipo TIN',
    total_net_assets_value: 'Patrimonio total',
    total_users: 'Usuarios',
    totally_refunded: 'Reembolso total',
    town: 'Localidad',
    transfer_country: 'País destino transferencia',
    transfer_nav_on_month_end: 'Valor de traspaso al cierre del mes (traspaso interno)',
    transfer_reference: 'Referencia de transferencia',
    trimestral_reporting: 'Indicador inf. trimestral',
    twitter: 'Twitter',
    type_name: 'Tipo nombre',
    updated_on: 'Actualizado',
    us_name: 'us_name',
    user_assigned: 'Usuario asignado',
    user_opened: 'Propietario',
    user_owner: 'Usuario propietario',
    username: 'Usuario',
    uuid: 'UUID',
    uuid_account: 'UUID Cuenta',
    uuid_agent: 'Agente',
    uuid_dealer: 'Distribuidor',
    uuid_distributor: 'UUID Distribuidor',
    uuid_fiscal_address: 'Dirección fiscal',
    uuid_group: 'UUID de grupo',
    uuid_group_assigned: 'Identificador grupo asignado',
    uuid_group_opened: 'Grupo abierto',
    uuid_intervener: 'UUID Interviniente',
    uuid_intervener_tax_address: 'ID dirección interviniente',
    uuid_issue_type: 'Tipo incidencia',
    uuid_owner: 'UUID Usuario propietario',
    uuid_permission_set: 'UUID de conjunto de permisos',
    uuid_postmail_address: 'Dirección postal',
    uuid_product: 'UUID de Producto',
    uuid_request: 'UUID operación de solicitud',
    uuid_subdealer: 'Subdistribuidor',
    uuid_subdistributor: 'UUID Subdistribuidor',
    uuid_subsidiary: 'Sucursal',
    uuid_user: 'UUID Usuario',
    uuid_user_assigned: 'Identificador usuario asignado',
    uuid_user_opened: 'Propietario',
    valid: 'Válido',
    validate_date: 'Fecha validez',
    validation_indicator: 'Estado validación',
    valoracion_inversion: 'Valoracion inversion',
    total_purchase_amount: 'Importe de compra',
    rentability: 'Rentabilidad',
    last_subscription_date: 'Fecha de última operación',
    has_active_periodic_subscription: 'Suscripción periódica',
    value_date: 'Fecha solicitud',
    volume: 'Tomo',
    withholding: 'Retenciones',
    withholding_group: 'Grupo retención',
    withholding_percentage: 'Porcentaje',
    withholding_tax_exemption: 'Indicador exención retención',
    withholding_tax_group: 'Grupo retención',
    work_phone: 'Teléfono trabajo',
    worth: 'Valor',
    xt_acount_origin: 'Cuenta de origen (traspaso)',
    xt_isin_code: 'Código isin (traspaso)',
    xt_fund_name: 'Nombre de plan (traspaso)',
    xt_fund_official_reg_number: 'Código CNMV (traspaso)',
    xt_fund_nif: 'CIF Fondo (traspaso)',
    xt_gestor: 'Gestora (traspaso)',
    xt_gestor_official_reg_number: 'C. CNMV Gestora/Comercializador (traspaso)',
    xt_gestor_nif: 'CIF Gestora/Comercializador (traspaso)',
    xt_provider: 'Comercializador (traspaso)',
    xt_provider_official_reg_number: 'Nº registro Comercializador (traspaso)',
    xt_provider_nif: 'CIF Comercializador (traspaso)',
    is_minor: 'Es menor de edad',
    is_class_manual: 'Clase asignada manualmente',
    has_document_expired: 'El documento ha expirado',
    gdpr_indicator: 'Indicador GDPR',
    residence_start_date: 'Fecha comienzo de residencia',
    residence_end_date: 'Fecha final de residencia',
    is_disabled_person: 'Es persona discapacitada',
    recovery_requested_on: 'Solicitud recuperación de contraseña',
    fiscal_amount: 'Cantidad fiscal',
    currency: 'Divisa',
    is_private: 'Es privada',
    name_target_product: 'Nombre del producto objetivo (traspaso interno)',
    has_docs_been_downloaded: 'Se ha descargado la documentación',
    reconciliation_status: 'Estado de conciliación',
    videoidentification_status: 'Estado de la video identificación',
    is_manually_validated: 'manualmente_validado',
    documentations_signature: 'Modalidad de firma',
    has_pending_bank_account_doc: 'Documentos pendientes de validar',
    data_protection_send_info: 'Envío de información',
    SEND_INFO: 'Envío de información',
    last_update: 'Fecha de actualización',
    comunication: 'Comunicación',
    external_codes: 'Códigos Externos',
    has_changed_distributor: 'Cambio de distribuidor',
};
